module.exports = __webpack_public_path__ + "assets/fda747bc6c998b63251166b1e6996e8d.svg";